<template>
  <div class="h-full modal">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        {{ title }}
      </h1>
      <ValidationObserver ref="validationObserver">
        <slot />
      </ValidationObserver>

      <alert
        v-if="error"
        type="error"
        class="mx-3"
      >
        {{ error }}
      </alert>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="onClose()"
      >
        {{ $t('modals.crudModal.cancel') }}
      </button>
      <button
        :disabled="isSubmitting"
        :class="operation.ctaClass"
        @click="submit()"
      >
        <span v-if="isSubmitting">{{ operation.submitting }}</span>
        <span v-else>{{ operation.cta }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/alert'

export const ACTIONS = {
  create: { ctaClass: 'btn-primary' },
  update: { ctaClass: 'btn-primary' },
  delete: { ctaClass: 'btn-danger' },
  generate: { ctaClass: 'btn-primary' },
  export: { ctaClass: 'btn-primary' },
  import: { ctaClass: 'btn-primary' },
  send: { ctaClass: 'btn-primary' },
  upgrade: { ctaClass: 'btn-danger' },
  downgrade: { ctaClass: 'btn-danger' }
}
export default {
  components: { Alert },
  props: {
    title: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    onSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    valdiationScope: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      validationError: '',
      isSubmitting: false
    }
  },
  computed: {
    operation () {
      // eslint-disable-next-line no-void
      void this.$i18n.locale
      return {
        ctaClass: ACTIONS[this.action].ctaClass,
        submitting: this.$t(`modals.crudModal.actions.${this.action}.submitting`),
        cta: this.$t(`modals.crudModal.actions.${this.action}.cta`)
      }
    },
    error () {
      return this.errorMessage || this.validationError
    }
  },
  methods: {
    async submit () {
      if (this.$refs.validationObserver) {
        const isValid = await this.$refs.validationObserver.validate()
        if (!isValid) {
          this.validationError = this.$t('modals.crudModal.validationError')
          return
        }
      }

      try {
        this.isSubmitting = true

        await this.onSubmit()

        this.isSubmitting = false
        this.onClose()
      } catch (error) {
        this.setValidationErrors(error, this.valdiationScope)
        this.isSubmitting = false
      }
    }
  }
}
</script>
